import React, { useState } from 'react';
import { Form, Button, Spinner } from 'react-bootstrap';
import TextInput from '../../form-generator/components/TextInput';
import { ArrowRight, CircleAlert } from 'lucide-react';
import { useHistory } from 'react-router';
import { PasswordIcon } from './LoginForm';

const SignupForm = ({ onSubmit, formSubmitting, error }) => {
  const history = useHistory();
  const [formData, setFormData] = useState({
    name: '',
    newAdmin: {
      confirmPassword: '',
      password: '',
      name: '',
      email: ''
    }
  });
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const handleInputChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleNestedInputChange = (parentField, field, value) => {
    setFormData(prev => ({
      ...prev,
      [parentField]: {
        ...prev[parentField],
        [field]: value
      }
    }));
  };

  const handleSubmit = async e => {
    e.preventDefault();

    const submitData = {
      ...formData
    };

    onSubmit(submitData);
  };

  return (
    <div>
      <Form id="organization-form" onSubmit={handleSubmit}>
        <Form.Group className="mb-3">
          <Form.Label>
            Organization Name <span className="text-danger">*</span>
          </Form.Label>
          <TextInput
            id="name"
            title="Organization Name"
            hint="Enter your organization name"
            required
            preValue={formData.name}
            onFormChange={e => handleInputChange('name', e.target.value)}
          />
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>
            Full Name <span className="text-danger">*</span>
          </Form.Label>
          <TextInput
            id="newAdmin.name"
            title="Admin Name"
            hint="Enter your name"
            required
            preValue={formData.newAdmin.name}
            onFormChange={e => handleNestedInputChange('newAdmin', 'name', e.target.value)}
          />
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>
            Email <span className="text-danger">*</span>
          </Form.Label>
          <TextInput
            id="newAdmin.email"
            title="Admin Email"
            variant="email"
            hint="Enter your email"
            required
            preValue={formData.newAdmin.email}
            onFormChange={e => handleNestedInputChange('newAdmin', 'email', e.target.value)}
          />
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>
            Password <span className="text-danger">*</span>
          </Form.Label>
          <div className="position-relative">
            <Form.Control
              className="bg-transparent"
              type={showPassword ? 'text' : 'password'}
              placeholder="Enter your password"
              value={formData.newAdmin.password}
              onChange={e => handleNestedInputChange('newAdmin', 'password', e.target.value)}
              required
              style={{ paddingRight: '35px', height: '44px' }}
            />
            <PasswordIcon showPassword={showPassword} onClick={() => setShowPassword(!showPassword)} />
          </div>
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>
            Confirm Password <span className="text-danger">*</span>
          </Form.Label>
          <div className="position-relative">
            <Form.Control
              className="bg-transparent"
              type={showConfirmPassword ? 'text' : 'password'}
              placeholder="Confirm your password"
              value={formData.newAdmin.confirmPassword}
              onChange={e => handleNestedInputChange('newAdmin', 'confirmPassword', e.target.value)}
              required
              style={{ paddingRight: '35px', height: '44px' }}
            />
            <PasswordIcon
              showPassword={showConfirmPassword}
              onClick={() => setShowConfirmPassword(!showConfirmPassword)}
            />
          </div>
        </Form.Group>

        <Button
          type="submit"
          disabled={formSubmitting}
          className="btn btn-primary font-weight-bold mt-2 w-100"
          style={{ backgroundColor: '#facc15' }}
        >
          <div className="d-flex align-items-center justify-content-center">
            Sign Up{' '}
            {formSubmitting ? (
              <Spinner size="sm" animation="border" className="ml-1" />
            ) : (
              <ArrowRight size={16} className="ml-1" />
            )}
          </div>
        </Button>

        {error && (
          <div className="alert alert-danger mt-2 midFont d-flex align-items-center">
            <CircleAlert size={16} className="mr-1" />
            {error}
          </div>
        )}

        <hr className="my-2" />

        <p
          style={{ fontSize: 12, cursor: 'pointer', textDecoration: 'underline' }}
          className={`text-center ${formSubmitting ? 'text-muted' : ''}`}
          onClick={() => {
            if (formSubmitting) return;
            history.push('/login');
          }}
        >
          Already have an account? Click here to login
        </p>
      </Form>
    </div>
  );
};
export default SignupForm;
